import { useContext, useMemo } from "react";
import { TabListStateContext } from "react-aria-components";

import * as S from "./MobileTabList.styled";
import TabsContext from "../TabsContext";
import { Select, type SelectItem } from "../../Select";

function MobileTabList() {
  const state = useContext(TabListStateContext);
  const { items, activeItemId, mobileHeading } = useContext(TabsContext);

  const selectItems = useMemo(() => {
    return items
      .filter((item) => !item.isDisabled)
      .map((item) => ({
        id: item.id,
        title: item.label,
        value: item.label,
      }));
  }, [items]);

  const selectedItem = selectItems.find((item) => {
    return item.id === activeItemId;
  });

  function handleChange(selectedItem: SelectItem | null | undefined) {
    if (state && selectedItem) {
      state.setSelectedKey(selectedItem.id);
    }
  }

  return (
    <S.Container>
      <Select
        labelProps={{
          label: mobileHeading,
        }}
        items={selectItems}
        selectedItem={selectedItem}
        onChange={handleChange}
      />
    </S.Container>
  );
}

export default MobileTabList;
